import { getNames } from 'country-list';

/**
 * Sorted list of all countries.
 */
export const countryList = getNames().sort();
